import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Text } from '@actual-app/components/text';
import { View } from '@actual-app/components/view';

import { subirBarco } from '#components/cuenta/subirBarco';
import { Boton } from '#components/mobile/ui/Boton';
import { color, texto } from '#components/mobile/ui/tokens';
import { useMetadataPref } from '#hooks/useMetadataPref';
import { useDispatch } from '#redux';

/**
 * Ajustes → «Amarre»: todo barco vive en este móvil y en la nube (decisión
 * del 4-nov-2026). Uno botado sin conexión se sube solo al volver la conexión
 * (`SubidaAutomatica`); aquí se puede subir a mano.
 */
export function AmarreSettings() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [id] = useMetadataPref('id');
  const [cloudFileId] = useMetadataPref('cloudFileId');
  const [subiendo, setSubiendo] = useState(false);
  const [aviso, setAviso] = useState<string | null>(null);

  const subir = async () => {
    setSubiendo(true);
    setAviso(null);
    const { error } = await subirBarco(dispatch, id);
    if (error === 'cofre-cerrado') {
      setAviso(t('To upload it, sign in again with your Rumbo password.'));
    } else if (error) {
      setAviso(t('Could not upload it. Check your connection and try again.'));
    }
    setSubiendo(false);
  };

  if (!cloudFileId) {
    return (
      <View style={{ gap: 12 }} data-testid="amarre-local">
        <Text style={{ ...texto.secundario, color: color.fg2 }}>
          <Trans>
            This boat is not in the cloud yet. It goes up by itself as soon as
            there is a connection.
          </Trans>
        </Text>
        <Boton
          bloque
          data-testid="amarre-subir"
          isDisabled={subiendo}
          onPress={() => void subir()}
        >
          {subiendo ? t('Uploading…') : t('Upload to the cloud')}
        </Boton>
        {aviso && (
          <Text role="alert" style={{ ...texto.secundario, color: color.bad }}>
            {aviso}
          </Text>
        )}
      </View>
    );
  }

  return (
    <View style={{ gap: 12 }} data-testid="amarre-nube">
      <Text style={{ ...texto.secundario, color: color.fg2 }}>
        <Trans>
          This boat is on this phone and in the cloud: you see it on all your
          devices and you do not lose it if you change phones.
        </Trans>
      </Text>
    </View>
  );
}
